export const lotsLabel = count => {
  if (!count) { return 'Lots'; }

  return `${count} ${1 === count ? 'Lot' : 'Lots'}`;
};
